import {useEffect, useState, useRef} from "react";
import NavBreadcrum from "components/NavBreadcrum";
import ButtonsActions from "views/utils/buttonsActions";
import TopBarActions from "components/TopBarActions";
import {SwalAlertChoice, SwalAlertClass} from "core/swalClass";
import axiApi from "ApiCaller";
import navs from "./navs";
import {TelegramUsersModel} from "site-apps/authuser/TelegramUsersModel";
import TableTelegramUsers from "./users-telegram/TableTelegramUsers";
import FormTelegramUser from "./users-telegram/FormTelegramUser";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import OrderingModel from "components/ordering/OrderingModel";
import ItemsModel from "core/itemsModel";

const buttonsActions = new ButtonsActions();

const ViewUsersTelegram = () => {
    const bread = [
        {name: "Administración", url: "/administration/", current: false},
        {name: "Usuarios de Telegram", current: true},
    ];

    document.title = "Usuarios de Telegram";

    const AlertQuestion = new SwalAlertChoice({
        icon: "info",
        iconColor: "#DD6B55",
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
    });

    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});

    const items = useRef(new ItemsModel());
    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const orderingRef = useRef(new OrderingModel());

    const [isLoading, setIsLoading] = useState(false);
    const [item, setItem] = useState({...TelegramUsersModel});
    const [panels, setPanels] = useState([]);
    const [organizations, setOrganizations] = useState([]);
    const [checkedAll, setCheckedAll] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [buttonsTB, setButtonsTB] = useState({
        ...new ButtonsActions(),
        title: document.title,
    });
    const [itemsShown, setItemsShown] = useState([]);

    const headersTable = [
        {name: "Activo", attr: 0, direction: "asc", active: false},
        {name: "Email", attr: 1, direction: "asc", active: true, default: true},
        {name: "Nombre", attr: 2, direction: "asc", active: false},
        {name: "Organizaciones", attr: 3, direction: "asc", active: false},
        {name: "Paneles", attr: 4, direction: "asc", active: false},
        {name: "Verificado", attr: 5, direction: "asc", active: false},
        {name: "Notificaciones", attr: 6, direction: "asc", active: false},
    ];

    useEffect(() => {
        const buttons = {...buttonsTB};
        buttons.title = document.title;
        buttons.edit.active = true;
        buttons.edit.onClick = onClickEdit;
        buttons.add.active = true;
        buttons.add.onClick = onClickAdd;
        buttons.add.disabled = false;
        buttons.delete.active = true;
        buttons.delete.onClick = onClickDelete;
        setButtonsTB(buttons);

        pagerModelRef.current.handleCallApi = () => fetchPostData();
        orderingRef.current.setHeaders(headersTable);
        orderingRef.current.applyOrder = () => fetchPostData();
        items.current.setItem = setItem;
        items.current.setShowPrev = setShowPreview;
        items.current.item = TelegramUsersModel;

        filters.current.filter = () => {
            pagerModelRef.current.paging.page = 1;
            fetchPostData();
        };

        fetchGetData();
    }, []);

    const fetchGetData = () => {
        setIsLoading(true);
        pagerModelRef.current.active = false;
        axiApi
            .get("/api/telegram/users/")
            .then((resp) => {
                if (resp.data) {
                    pagerModelRef.current.active = resp.data.items.length > 0;
                    items.current.showed = [...resp.data.items];
                    setItemsShown([...resp.data.items]);
                    setPanels(resp.data.panels || []);
                    setOrganizations(resp.data.organizations || []);
                    pagerModelRef.current.paging.setPager(resp.data);
                } else {
                    Alert.warning("Error", "Error en el servidor");
                }
            })
            .catch((error) => {
                console.error(error);
                Alert.warning("Error", "Error en el servidor");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const fetchPostData = () => {
        setIsLoading(true);
        pagerModelRef.current.active = false;
        axiApi
            .post("/api/telegram/users/", filters.current.chosen, {
                params: {...pagerModelRef.current.paging.getParams(), ...orderingRef.current.getParams()},
            })
            .then((resp) => {
                if (resp.data) {
                    pagerModelRef.current.active = resp.data.items.length > 0;
                    items.current.setShowed(resp.data.items);
                    setItemsShown([...items.current.showed]);
                    pagerModelRef.current.paging.setPager(resp.data);
                } else {
                    Alert.warning("Error", "Error en el servidor");
                }
            })
            .catch((error) => {
                console.error(error);
                Alert.warning("Error", "Error en el servidor");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const onClickEdit = () => {
        if (items.current.chosen.length === 1) {
            let chosen = items.current.showed.find((item) => item.id === items.current.chosen[0]);
            setItem(chosen);
            setShowForm(true);
        }
    };

    const onClickAdd = () => {
        setItem({...TelegramUsersModel});
        setShowForm(true);
    };

    const onClickDelete = () => {
        let users = items.current.showed
            .filter((item) => items.current.chosen.includes(item.id))
            .map((item) => item.id);

        if (!users.length) {
            Alert.warning("Error", "No se ha seleccionado ningún usuario.");
            return false;
        }

        AlertQuestion.fire("Confirmar borrado", "¿Estás seguro de eliminar los usuarios de Telegram seleccionados?").then((quest) => {
            if (quest.isConfirmed) {
                axiApi
                    .post("/api/telegram/users/delete/", {users: users})
                    .then((r) => {
                        if (r.data.status) {
                            fetchGetData();
                        } else {
                            Alert.warning("Error", r.data.message);
                        }
                    })
                    .catch((r) => {
                        console.error(r);
                        Alert.warning("Error", "Error en el servidor");
                    });
            }
        });
    };

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <TopBarActions actions={buttonsTB} filtersRef={filters} />
            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="125px" chosen={items.current.chosen} />
            <div className="row">
                <div className="col">
                    <LoaderSpinner isLoading={isLoading}>
                        <TableTelegramUsers
                            itemsShow={itemsShown}
                            items={items}
                            checkAll={checkedAll}
                            setCheckAll={setCheckedAll}
                            buttonsTB={buttonsTB}
                            setButtonsTB={setButtonsTB}
                            orderingRef={orderingRef}
                        />
                    </LoaderSpinner>
                </div>
            </div>
            <FormTelegramUser
                setShowCanvas={setShowForm}
                showCanvas={showForm}
                item={item}
                items={items}
                setItem={setItem}
                setItemsShown={setItemsShown}
                organizations={organizations}
                panels={panels}
                reloadData={fetchGetData}
            />
        </>
    );
};

export default ViewUsersTelegram;
